import { RenewalNoticesService } from 'src/app/pages/renewal-notices/renewal-notices.service';
import {
  ChangeDetectorRef,
  Component,
  DestroyRef,
  effect,
  inject,
  Input,
  ViewChild
} from '@angular/core';

import {
  QueryParamsModel,
  TableColumn
} from 'src/app/layouts/components/common-table/common-table.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppSettingsService } from 'src/app/core/app-settings.service';
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationExtras,
  Router
} from '@angular/router';
import { ViewPdfComponent } from 'src/app/pages/master-data/program-config/components/view-pdf/view-pdf.component';
import { ProgramBrandingService } from './program-branding.service';
import { UserAuthenticationService } from 'src/app/core/navigation/user-authentication.service';
import { DataService } from 'src/app/pages/home/program-license-agreement-process/data.service';
import { ProgramIfcService } from '../../service/programIfc.service';
import { environment } from 'src/assets/environments/environment.prod';
import { firstValueFrom, Subject, Subscription } from 'rxjs';
import Swal from 'sweetalert2';
import { MultipleRowCommonTableComponent } from 'src/app/layouts/components/multiple-row-common-table/multiple-row-common-table.component';
import { MatTableDataSource } from '@angular/material/table';
import { RejectBrandComponent } from './component/reject-brand/reject-brand.component';
import { PreviewBrandCertificateComponent } from './component/preview-brand-certificate/preview-brand-certificate.component';
import moment from 'moment';
import { ViewImageComponent } from 'src/app/core/shared/view-image/view-image.component';
import { ListConfigurationService } from 'src/app/pages/list-configuration/list-configuration.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { ViewAttachmentsService } from 'src/app/core/shared/services/view-attachments.service';
import { ZipFileService } from 'src/app/core/shared/services/zip-file.service';
import { ViewTrademarkArtworkComponent } from './component/product-label-list/component/view-trademark-artwork/view-trademark-artwork.component';
import { BrandHistoryListComponent } from './component/brand-history-list/brand-history-list.component';
import { BrandChangeRequestComponent } from './component/brand-change-request/brand-change-request.component';
import { BrandEditComponent } from './component/brand-edit/brand-edit.component';
import { SwalDialogService } from 'src/app/core/shared/services/swal-dialog.service';
@Component({
  selector: 'vex-program-branding',
  standalone: true,
  imports: [MultipleRowCommonTableComponent],
  templateUrl: './program-branding.component.html',
  styleUrls: ['./program-branding.component.scss']
})
export class ProgramBrandingComponent {
  public actions: Array<any> = [];
  public burgerActions: Array<any> = [];
  public innerActions: Array<any> = [];
  title: string = 'Brands';

  public multiTableColumns: TableColumn<any>[] = [];

  innerColumns: TableColumn<any>[] = [];
  loadedInnerColumns: TableColumn<any>[] = [];

  burgerInnerActions: any[] = [];
  @ViewChild('table', { static: false })
  multipleRowCommonTableRef!: MultipleRowCommonTableComponent;
  userRole: string | null;
  userInfo: any;
  filter: any = {};
  @Input() programConfigId: any;
  currentProgram: any;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  isLoading = true;
  multiRowTableData: any;
  tableData: any;
  private subscription: Subscription;
  private isComponentInitialized: boolean = false;
  toggleSwitchStr = 'brands';
  companyId: any;
  private readonly destroyRef: DestroyRef = inject(DestroyRef);
  crumbs: any = '';
  defaultActions = [
    {
      key: 'viewFile',
      icon: 'mat:remove_red_eye',
      property: 'fileUrl',
      label: 'View Form 07',
      fileName: 'Form IFC07 - Application for Product Brand Name Registration',
      toolTip: 'View Form 07'
    }
  ];

  constructor(
    private dialog: MatDialog,
    public appSettingsService: AppSettingsService,
    private programBrandingService: ProgramBrandingService,
    public userCheck: UserAuthenticationService,
    private dataService: DataService,
    private _router: Router,
    private programIfcService: ProgramIfcService,
    private listConfigurationService: ListConfigurationService,
    private route: ActivatedRoute,
    private _cdr: ChangeDetectorRef,
    private loaderService: LoaderService,
    private viewAttachmentsService: ViewAttachmentsService,
    private zipFileService: ZipFileService,
    private renewalNoticesService: RenewalNoticesService,
    private swalDialogService: SwalDialogService
  ) {
    effect(
      () => {
        let brandTerminationResp =
          this.renewalNoticesService.brandTerminationPayloadSignal();
        if (
          brandTerminationResp &&
          brandTerminationResp?.type == 'BrandUpdate'
        ) {
          this.onBrandUpdate(brandTerminationResp.data);
        }
      },
      {
        allowSignalWrites: true
      }
    );
  }
  type: any = null;
  async ngOnInit() {
    this.userInfo = this.appSettingsService.userData().userDetails;
    this.companyId = this.route.snapshot.queryParams['companyId'];
    this.multiTableColumns = [
      { label: 'ID', property: 'id', type: 'text', visible: false },
      {
        label: 'Toggle',
        property: 'sample',
        type: 'toggle',
        visible: true,
        remove: true
      },
      {
        label: 'Company',
        property: 'CompanyName',
        type: 'text',
        visible: this.userCheck.checkUser()
      },
      {
        label: 'Formulation Approval Code',
        property: 'formulationApprovalCode',
        type: 'text',
        visible: true
      },
      {
        label: 'Date Submitted',
        property: 'dateSubmitted',
        type: 'text',
        visible: true
      },
      {
        label: 'Specification',
        property: 'SpecName',
        type: 'text',
        visible: true
      },
      {
        label: 'Viscosity Grade',
        property: 'VisGrade',
        type: 'text',
        visible: true
      },
      {
        label: 'Brand Approve Status',
        property: 'BrandApprove',
        type: 'text',
        visible: true
      },

      {
        label: 'Actions',
        property: 'actions',
        type: 'button',
        visible: true
      }
    ];

    this.isComponentInitialized = true;
    this.type = this.route.snapshot.queryParams['type'];
    if (this.type == 'brand') {
      this.title = 'Brands';
    } else if (this.type == 'brandNames') {
      this.title = 'Product Brand Names';
    } else if (this.type == 'product-label-list') {
      this.title = 'Product Labeling';
    } else if (this.type == 'marketingMaterials') {
      this.title = 'Marketing Materials';
    } else if (this.type == 'BrandRegistrationCertificates') {
      this.title = 'Brand Registration Certificates';
    } else if (this.type == 'WebsiteBrandList') {
      this.title = 'Website Brand List';
    } else if (this.type == 'brand-label-development') {
      this.title = 'Brand Label Development';
    } else {
      // Redirect to the error 404 page if the type is not recognized
      // this._router.navigate(['/program/not-found']);
      // this._router.navigate(['/sample'], {
      //   queryParams: {
      //     type: 'SubmittedFormulations'
      //   }
      // });
    }

    this.isComponentInitialized = true;
    this.type = this.route.snapshot.queryParams['type'];
    await this.getListViewColumns('brand');

    this.userRole = this.appSettingsService.getUserRole();

    this.filter.where = {
      programConfigId: this.programConfigId
    };
    if (this.userCheck.checkUser()) {
      this.burgerActions.push(
        { key: 'view', icon: 'mat:description', label: 'View Form 07' },
        {
          key: 'approveBrand',
          icon: 'mat:edit',
          label: 'Approve'
        },
        {
          key: 'rejectAllBrand',
          icon: 'mat:cancel',
          label: 'Reject All Brand'
        }
      );
      this.burgerInnerActions.push(
        { key: 'modify', icon: 'mat:edit', label: 'Modify' },
        { key: 'brandUnpublish', icon: 'mat:publish', label: 'Unpublish' },
        { key: 'brandPublish', icon: 'mat:publish', label: 'Publish' },
        {
          key: 'history',
          label: 'View History',
          icon: 'mat:history'
        },
        { key: 'ChangeRequest', icon: 'mat:edit', label: 'Update Request' },
        { key: 'terminate', icon: 'mat:block', label: 'Terminate' },
        { key: 'reactivate', icon: 'mat:autorenew', label: 'Reactivate' },
        { key: 'rejectBrand', icon: 'mat:cancel', label: 'Reject brand' }
      );

      const actionsIndex = this.multiTableColumns.findIndex(
        (column) => column.property === 'actions'
      );

      const newColumns: TableColumn<any>[] = [
        {
          label: 'Company',
          property: 'CompanyName',
          type: 'text',
          visible: true
        }
      ];

      // Insert new columns before the "Actions" column
      // this.columns.splice(actionsIndex, 0, ...newColumns);
    } else {
      this.actions = this.defaultActions;
      this.burgerActions = [];
      this.burgerInnerActions = [];

      this.innerActions.push(
        {
          key: 'dynamicBtn',
          property: 'history',
          label: 'View History',
          toolTip: 'View brand history'
        },
        {
          key: 'dynamicBtn',
          property: 'ChangeRequest',
          label: 'Change Request',
          toolTip: 'Brand change request'
        }
      );
    }

    //subscribe program value selected
    this.subscription = this.dataService.program$.subscribe((res: any) => {
      if (res) {
        this.programConfigId = res?.id;
        if (!this.isComponentInitialized) {
          // Only call if the component is not initializing
          // setTimeout(() => {
          this.multipleRowCommonTableRef.initLoadItems();
          // }, 1000);
        }

        // After initial setup, set the flag to false
        this.isComponentInitialized = false;
      }
    });

    // this.subscription = this.dataService
    //   .getProgramCartObservable()
    //   .subscribe((res) => {
    //     if (res) {
    //       this.init();
    //       if (!this.isComponentInitialized) {
    //         // Only call if the component is not initializing
    //         // setTimeout(() => {
    //         this.multipleRowCommonTableRef.initLoadItems();
    //         // }, 1000);
    //       }

    //       // After initial setup, set the flag to false
    //       this.isComponentInitialized = false;
    //     }
    //   });
    // this.listRefreshService
    //   .getListObservable()
    //   .pipe(takeUntil(this._unsubscribeAll))
    //   .subscribe((res) => {
    //     if (res) {
    //       if (!this.isComponentInitialized) {
    //         // Only call if the component is not initializing
    //         setTimeout(() => {
    //           this.multipleRowCommonTableRef.initLoadItems();
    //         }, 1000);
    //       }

    //       // After initial setup, set the flag to false
    //       this.isComponentInitialized = false;
    //     }
    //   });

    this._router.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.type = null;
          this.type = this.route.snapshot.queryParams['type'];
          this.companyId = this.route.snapshot.queryParams['companyId'];
          if (this.type == 'brands') {
            this.title = 'Brands';
          } else if (this.type == 'brandNames') {
            this.title = 'Product Brand Names';
          } else if (this.type == 'product-label-list') {
            this.title = 'Product Labeling';
          } else if (this.type == 'marketingMaterials') {
            this.title = 'Marketing Materials';
          } else if (this.type == 'BrandRegistrationCertificates') {
            this.title = 'Brand Registration Certificates';
          } else if (this.type == 'WebsiteBrandList') {
            this.title = 'Website Brand List';
          } else if (this.type == 'brand-label-development') {
            this.title = 'Brand Label Development';
          } else {
            // Redirect to the error 404 page if the type is not recognized
            // this._router.navigate(['/program/not-found']);
            // this._router.navigate(['/brand'], {
            //   queryParams: {
            //     type: 'brand'
            //   }
            // });
          }
          this.multipleRowCommonTableRef.initLoadItems();
        }
      });

    if (this.userCheck.checkUser()) {
      this.crumbs = '';
    } else {
      this.crumbs = { label: 'Dashboard', path: '/program/dashboard' };
    }
  }
  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  async init() {
    try {
      this.currentProgram = await firstValueFrom(
        this.dataService.getUserData()
      );

      if (this.currentProgram) {
        this.programConfigId = this.currentProgram?.id;
      } else {
        this.subscription = this.dataService.program$.subscribe((res: any) => {
          if (res) {
            this.programConfigId = res?.id;
          }
        });
      }
      this.inItFilterOptions();
    } catch (err) {
      console.error('err :>> ', err);
    }
  }

  inItFilterOptions() {
    let url = this._router.url;
    this.filter.where = {
      companyId: !this.userCheck.checkUser()
        ? this.userInfo?.company?.id
        : this.companyId
        ? this.companyId
        : null,

      programConfigId: this.programConfigId,
      uploadToWebsite: this.type == 'WebsiteBrandList' ? 'true' : null,
      BrandApprove: this.type == 'WebsiteBrandList' ? 'Yes' : null,
      BrandStatus: this.type == 'WebsiteBrandList' ? 'Active' : null,
      type: this.toggleSwitchStr == 'brands' ? 'Group' : null
    };
  }
  /**
   * onLoadItemsEvent
   */
  public async onLoadItemsEvent(queryParams: QueryParamsModel) {
    this.isLoading = true;

    await this.init();

    const retData: any = {
      items: [],
      totalCount: 0,
      error: ''
    };
    // this.multipleRowCommonTableRef.loadItems(retData);

    if (Object.keys(this.filter).length) {
      queryParams.filter = JSON.stringify(this.filter);
    }
    this.programBrandingService
      .getBrandingList(queryParams)
      .subscribe((resp) => {
        // this.tableData = null;
        // this.multiRowTableData = null;
        this.tableData = resp;

        const groupedData: {
          [key: string]: {
            companyDetails: any;
            brandData: any[];
            brandBulkApprove: boolean;
            brandBulkReject: boolean;
            BrandApprove: string;
          };
        } = {};

        resp.items.forEach((brand: any, index: number) => {
          const brandRequestId = brand.BrandRequestId;

          if (!groupedData[brandRequestId]) {
            groupedData[brandRequestId] = {
              dateSubmitted: brand.dateSubmitted,
              ...brand?.companyDetails,
              companyId: +brand?.companyDetails?.id,
              id: index,
              brandData: [],
              BrandRequestId: brand?.BrandRequestId,
              file: {
                fileUrl: brand?.fileUrl,
                originalFileName: brand?.originalFileName
              },
              sampleID: brand?.sampleID,
              brandBulkApprove: true,
              brandBulkReject: true,
              programConfigId: brand?.programConfigId,

              BrandApprove: brand?.BrandApprove,
              fileUrl: brand?.fileUrl,
              brandMarksAttachments: brand?.brandMarksAttachments,
              sampleDetails: brand?.formulationDetails,
              formulationApprovalCode:
                brand?.formulationDetails?.formulationApprovalCode,
              BrandStatus: brand.BrandStatus || 'Pending',
              SpecName: brand?.formulationDetails?.sampleDetails?.SpecName,
              VisGrade: brand?.formulationDetails?.sampleDetails?.VisGrade,
              userDetails: brand?.userDetails
            };
          }
          // BrandStatus: brand.BrandStatus || 'Pending',
          groupedData[brandRequestId].brandData.push(brand);

          groupedData[brandRequestId].brandBulkApprove = groupedData[
            brandRequestId
          ].brandData.some((i) => i.BrandApprove === 'Pending');
          groupedData[brandRequestId].BrandApprove = groupedData[
            brandRequestId
          ].brandData.some((i) => i.BrandApprove === 'Pending')
            ? 'Pending'
            : brand.BrandApprove;
        });

        let data: any[] = [];
        // Convert groupedData to an array and push to retData.items
        data = Object.values(groupedData);
        data.forEach((item) => {
          retData.items.unshift({
            ...item,
            fileUrl: item?.fileUrl,
            innerTableData: new MatTableDataSource(item.brandData)
          });
        });
        setTimeout(() => {
          retData.totalCount = this.tableData.totalCount;
          this.multiRowTableData = retData;
          this.multipleRowCommonTableRef.loadItems(retData);
          this.onBrandToggleList(this.toggleSwitchStr);
          this.isLoading = false;
        }, 100);
      });
  }

  onActionClickEmit(ev: any) {
    let key = ev.action.key;

    switch (key) {
      case 'approve':
        break;
      case 'delete':
        break;
      case 'fileCertificate':
        this.viewFileData(ev.data);
        break;
      case 'upload':
        this.onUpload(ev.data);
        break;
      case 'viewProcess':
        this.onViewProcess(ev?.data);
        break;
      case 'view':
        this.dialog.open(ViewPdfComponent, {
          width: '80%',
          data: {
            src: ev.data.file.fileUrl,
            title:
              'Form IFC07 - Application for Product Brand Name Registration'
          }
        });
        break;
      case 'approveBrand':
        const { innerTableData, ...restOfData } = ev.data;
        this.dataService.setProgramBrand(restOfData);
        this._router.navigate([
          `programs/brands/approve/${ev.data.BrandRequestId}`
        ]);
        break;
      case 'rejectAllBrand':
        this.onRejectAllBrand(ev.data);
        break;
      case 'viewInnerFile':
        this.dialog.open(ViewPdfComponent, {
          width: '80%',
          data: {
            src: ev.data.fileUrl,
            title: 'Form 07'
          }
        });
        break;
      case 'viewInnerMark':
        this.dialog.open(ViewImageComponent, {
          width: '40%',
          data: {
            image: ev.data.brandMarksUrl,
            title: 'Trademark artwork'
          }
        });
        break;

      case 'downloadInnerMark':
        this.onDownloadMark(ev.data.brandMarksUrl, 'logo');
        break;
      case 'downloadInnerFile':
        this.onDownloadMark(ev.data.file.fileUrl, 'file');
        break;
      case 'brandUnpublish':
        this.onBrandUploadWebsite(ev.data, 'No');
        break;
      case 'brandPublish':
        this.onBrandUploadWebsite(ev.data, 'Yes');
        break;
      case 'ChangeRequest':
        this.onBrandRequestChange(ev.data);
        break;
      case 'history':
        this.onViewBrandHistoryListById(ev.data);
        break;

      case 'terminate':
        this.onBrandStatusChange(ev.data, 'terminate');
        break;
      case 'reactivate':
        this.onBrandStatusChange(ev.data, 'reactivate');
        break;
      case 'modify':
        this.onBrandModify(ev.data);
        break;

      case 'rejectBrand':
        this.onRejectBrand(ev.data);
        break;

      default:
        break;
    }
  }

  onDownloadMark(ev: any, filename: string) {
    const fileUrl = ev;

    // Create a temporary link element
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = filename; // You can set the desired filename here
    document.body.appendChild(link);

    // Trigger a click on the link to start the download
    link.click();

    // Remove the link from the DOM
    document.body.removeChild(link);
  }
  onOpenCoreFormulationAgreement() {
    this._router.navigate(['']);
  }

  onAddClick() {}

  viewFileData(ev: any) {
    const programImg =
      environment.mediaUrl +
      ev?.programConfigDetails?.attachment[0]?.dir +
      '/' +
      ev?.programConfigDetails?.attachment[0]?.fileName;
    const data = {
      programImg: programImg,
      companyName: ev?.CompanyName || '-',
      brandName: ev?.brandName || 'brand',
      grade: ev?.VisGrade || '-',
      specification: ev?.SpecName || '-',
      registrationId: ev?.brandNameRegistrationId || '-',
      expiryDate: moment(ev?.createdAt).format('YYYY MMMM DD') || '-'
    };

    let dialogRef = this.dialog.open(PreviewBrandCertificateComponent, {
      data: {
        data: data,
        isLoading: false
      },
      autoFocus: false,
      width: '100%'
    });
  }

  onDownload(ev: any) {
    const programImg =
      environment.mediaUrl +
      ev?.programConfigDetails?.attachment[0]?.dir +
      '/' +
      ev?.programConfigDetails?.attachment[0]?.fileName;
    const data = {
      programImg: programImg,
      companyName: ev?.companyName || '-',
      brandName: ev?.brandName || 'brand',
      grade: ev?.programConfigId || '-',
      specification: ev?.programName || '-',
      registrationId: ev?.brandNameRegistrationId || '-',
      expiryDate: ev?.createdAt || '-'
    };
    this.programIfcService.downloadPDF(data);
  }
  onUpload(ev: any) {
    const data = {
      companyName: ev?.companyName,
      brandName: ev?.brandName || 'brand',
      grade: ev?.programConfigId,
      specification: ev?.programName,
      registrationId: ev?.brandNameRegistrationId,
      expiryDate: ev?.createdAt
    };
    this.programIfcService.onUpload(data);
  }

  onViewProcess(ev: any) {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        id: 45,
        type: 'brand',
        programConfig: ev?.programConfigDetails?.id,
        userId: ev.createdBy
      }
    };
    let programData = {
      programId: ev.programConfigDetails?.id
    };

    this.dataService.setProgramByIDData(programData);
    this._router.navigate([`/signed-program/add/`], navigationExtras);
  }

  onApproveBrand(id: any) {
    Swal.fire({
      title: 'Brand Approve',
      text: `Are you sure you want to approve the brand.`,
      icon: 'info',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        let data: any = {
          BrandStatus: 'Active',
          BrandApprove: 'Yes'
        };

        try {
          let resp = firstValueFrom(
            this.programBrandingService.updateBrand(id, data)
          );
          this.multipleRowCommonTableRef.initLoadItems();
        } catch (err) {
          this.appSettingsService.handleError(err);
        }
      }
    });
  }

  onRejectAllBrand(ev: any) {
    const { innerTableData, ...restOfData } = ev;

    // Open the dialog and assign the result to dialogRef
    const dialogRef = this.dialog.open(RejectBrandComponent, {
      width: '60%',
      data: { ...restOfData, title: `Reject Brands - ${ev.CompanyName}` },
      autoFocus: false
    });

    // Subscribe to the dialog close event
    dialogRef.afterClosed().subscribe((resp) => {
      if (resp) {
        setTimeout(() => {
          this.multipleRowCommonTableRef.initLoadItems();
        }, 1000);
      }
    });
  }
  columns: any[] = [];
  onBrandToggleList(ev: any) {
    this.columns = [];
    this.loadedInnerColumns = [];
    this.isLoading = true;
    if (ev == 'report') {
      this.toggleSwitchStr = 'report';
      this.columns = [...this.innerColumns];
      // .filter(
      //   (i) =>
      //     i.property !== 'form07' &&
      //     i.property !== 'trademarkArtwork' &&
      //     i.property !== 'actions'
      // );

      this.loadedInnerColumns = [];
      setTimeout(() => {
        this.burgerActions = [];

        if (this.userCheck.checkUser()) {
          this.burgerActions.push(
            { key: 'modify', icon: 'mat:edit', label: 'Modify' },
            { key: 'brandUnpublish', icon: 'mat:publish', label: 'Unpublish' },
            { key: 'brandPublish', icon: 'mat:publish', label: 'Publish' },
            {
              key: 'history',
              label: 'View History',
              icon: 'mat:history'
            },
            {
              key: 'ChangeRequest',
              icon: 'mat:edit',
              label: 'Update Request'
            },
            { key: 'terminate', icon: 'mat:block', label: 'Terminate' },
            { key: 'reactivate', icon: 'mat:autorenew', label: 'Reactivate' },
            { key: 'rejectBrand', icon: 'mat:cancel', label: 'Reject brand' }

            // { key: 'view', icon: 'mat:description', label: 'View Form 07' },
            // {
            //   key: 'viewInnerMark',
            //   icon: 'mat:remove_red_eye',
            //   label: 'View trademark artwork'
            // },
            // {
            //   key: 'downloadInnerMark',
            //   icon: 'mat:download',
            //   label: 'Download trademark artwork'
            // }
          );
        } else {
          // this.columns = [...this.innerColumns].filter(
          //   (i) => i.property !== 'actions'
          // );
          // this.burgerActions.push(
          //   { key: 'view', icon: 'mat:remove_red_eye', label: 'View Form 07' },
          //   {
          //     key: 'viewInnerMark',
          //     icon: 'mat:remove_red_eye',
          //     label: 'View trademark artwork'
          //   },
          //   {
          //     key: 'downloadInnerMark',
          //     icon: 'mat:download',
          //     label: 'Download trademark artwork'
          //   }
          // );
          this.actions = [];
          this.actions.push(
            {
              key: 'dynamicBtn',
              property: 'history',
              label: 'View History',
              toolTip: 'View  brand history'
            },
            {
              key: 'dynamicBtn',
              property: 'ChangeRequest',
              label: 'Change Request',
              toolTip: 'Brand change request'
            }
          );
          // this.actions = this.defaultActions;
          // this.columns.push({
          //   label: 'Actions',
          //   property: 'actions',
          //   type: 'button',
          //   visible: true
          // });
        }
        this.multipleRowCommonTableRef.loadItems(this.tableData);
        this.isLoading = false;
        this._cdr.detectChanges();
      }, 500);
    } else {
      this.loadedInnerColumns = [];
      this.toggleSwitchStr = 'brands';
      this.columns = this.multiTableColumns;
      this.loadedInnerColumns = this.innerColumns;

      setTimeout(() => {
        this.multipleRowCommonTableRef.loadItems(this.multiRowTableData);
        this.burgerActions = [];

        if (this.userCheck.checkUser()) {
          this.burgerActions.push(
            { key: 'view', icon: 'mat:description', label: 'View Form' },
            {
              key: 'approveBrand',
              icon: 'mat:edit',
              label: 'Approve'
            },
            {
              key: 'rejectAllBrand',
              icon: 'mat:cancel',
              label: 'Reject brand'
            }
          );
        } else {
          this.actions = this.defaultActions;
        }
        this.isLoading = false;
        this._cdr.detectChanges();
      }, 500);

      this._cdr.detectChanges();
    }
  }
  dynamicColumnBrands: any[];
  async getListViewColumns(page: string) {
    try {
      const resp = await firstValueFrom(
        this.listConfigurationService.getlistViewColumns(page)
      );
      let respItems: any = resp.items[0].columns;
      let string = this.userCheck.checkUser() ? 'isCQA' : 'isCompany';
      const filteredColumn = respItems.tableColumn.filter(
        (i: any) => i['isCompany'] || i['isSecondary']
      );
      const newColumn = this.userCheck.checkUser()
        ? respItems.tableColumn.map((item: any) => ({
            label: item.label,
            property: item.property,
            type: 'text',
            visible: item.isCQA ? true : false,
            tableName: item.tableName
          }))
        : filteredColumn.map((item: any) => ({
            label: item.label,
            property: item.property,
            type: 'text',
            visible: item.isCompany ? true : item.isSecondary ? false : false,
            tableName: item.tableName
          }));
      this.innerColumns =
        Array.isArray(newColumn) && newColumn?.length > 0
          ? newColumn
          : this.innerColumns;
      setTimeout(() => {
        if (this.userCheck.checkUser()) {
          this.innerColumns.push(
            {
              label: 'Published status',
              property: 'uploadToWebsite',
              type: 'text',
              visible: true
            },
            {
              label: 'Change Request ',
              property: 'CompanyChangeRequest',
              type: 'text',
              visible: true
            },
            {
              label: 'Form 07',
              property: 'form07',
              type: 'ActionButtonColumns',
              visible: true,
              ActionButtonColumns: [
                {
                  key: 'viewFile',
                  label: 'View',
                  icon: 'mat:remove_red_eye',
                  property: 'fileUrl',
                  fileName:
                    'Form IFC07 - Application for Product Brand Name Registration',
                  toolTip: 'View Form 07'
                },
                {
                  key: 'download',
                  label: 'download',
                  icon: 'mat:down_arrow',
                  property: 'fileUrl',
                  fileName:
                    'Form IFC07 - Application for Product Brand Name Registration',
                  toolTip: 'Download Form 07'
                }
              ]
            },
            {
              label: 'Trademark artwork',
              property: 'trademarkArtwork',
              type: 'ActionButtonColumns',
              visible: true,
              ActionButtonColumns: [
                {
                  key: 'dynamicBtn',
                  label: 'View',
                  icon: 'mat:remove_red_eye',
                  property: 'brandMarksUrl',
                  fileName: 'Trademark artwork',
                  toolTip: 'View Trademark artwork',
                  actionType: 'images'
                },
                {
                  key: 'dynamicBtn',
                  label: 'download',
                  icon: 'mat:down_arrow',
                  property: 'brandMarksUrl',
                  fileName: 'Trademark artwork',
                  toolTip: 'Download Trademark artwork',
                  actionType: 'files'
                }
              ]
            },
            {
              label: 'Actions',
              property: 'actions',
              type: 'button',
              visible: true
            }
          );
        } else {
          this.innerColumns.push(
            {
              label: 'Published status',
              property: 'uploadToWebsite',
              type: 'text',
              visible: true
            },
            {
              label: 'Change Request ',
              property: 'CompanyChangeRequest',
              type: 'text',
              visible: true
            },

            {
              label: 'Form 07',
              property: 'form07',
              type: 'ActionButtonColumns',
              visible: true,
              ActionButtonColumns: [
                {
                  key: 'viewFile',
                  label: 'View',
                  icon: 'mat:remove_red_eye',
                  property: 'fileUrl',
                  fileName:
                    'Form IFC07 - Application for Product Brand Name Registration',
                  toolTip: 'View Form 07'
                },
                {
                  key: 'download',
                  label: 'download',
                  icon: 'mat:down_arrow',
                  property: 'fileUrl',
                  fileName:
                    'Form IFC07 - Application for Product Brand Name Registration',
                  toolTip: 'Download Form 07'
                }
              ]
            },
            {
              label: 'Trademark artwork',
              property: 'trademarkArtwork',
              type: 'ActionButtonColumns',
              visible: true,
              ActionButtonColumns: [
                {
                  key: 'dynamicBtn',
                  label: 'View',
                  icon: 'mat:remove_red_eye',
                  property: 'isBrandApprove',
                  fileName: 'Trademark artwork',
                  toolTip: 'View Trademark artwork',
                  actionType: 'images'
                },
                {
                  key: 'dynamicBtn',
                  label: 'download',
                  icon: 'mat:down_arrow',
                  property: 'isBrandApprove',
                  fileName: 'Trademark artwork',
                  toolTip: 'Download Trademark artwork',
                  actionType: 'files'
                }
              ]
            },
            {
              label: 'Actions',
              property: 'actions',
              type: 'button',
              visible: true
            }
          );
        }

        this.columns = this.multiTableColumns;
        this.loadedInnerColumns = this.innerColumns;
      }, 200);
    } catch (err) {
      this.appSettingsService.handleError(err);
    }
  }

  onBrandUploadWebsite(ev: any, str: string) {
    Swal.fire({
      title: `Brand ${str == 'No' ? 'unpublish' : 'publish'}`,
      text: `Are you sure you want to ${
        str == 'No' ? 'unpublish' : 'publish'
      } the brand?`,
      icon: 'info',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.loaderService.show();
        let data: any = {
          uploadToWebsite: str == 'No' ? false : true
        };

        try {
          let resp = await firstValueFrom(
            this.programBrandingService.updateBrand(ev.brandId, data)
          );
          this.multipleRowCommonTableRef.initLoadItems();
          this.loaderService.hide();
        } catch (err) {
          this.appSettingsService.handleError(err);
          this.loaderService.hide();
        }
      }
    });
  }

  onActionColumnClick(ev: any) {
    switch (ev.key) {
      case 'files':
        this.onDownloadMultipleFilesAsZip(ev.data);
        break;
      case 'images':
        this.onViewMultipleTypeFiles(ev.data);
        break;

      default:
        break;
    }
  }

  async onDownloadMultipleFilesAsZip(ev: any) {
    const files = ev.brandMarksAttachments || [];
    this.loaderService.show();

    // Process each file asynchronously using Promise.all
    const multipleFiles = await Promise.all(
      files.map(async (file: any) => {
        const fileExtension: string =
          this.viewAttachmentsService.getFileExtensionFromUrl(file.file);
        let blob: any;

        // Fetch the appropriate blob based on file extension
        if (fileExtension === 'pdf') {
          blob = await this.appSettingsService.PdfUrlToBlob(file.file);
        } else if (
          fileExtension === 'jpg' ||
          fileExtension === 'png' ||
          fileExtension === 'jpeg' ||
          fileExtension === 'svg'
        ) {
          blob = await this.appSettingsService.ImageUrlToBlob(file.file);
        } else if (fileExtension === 'txt') {
          blob = await this.appSettingsService.TextFileUrlToBlob(file.file);
        }

        // If the blob was fetched, prepare the file for the zip
        if (blob) {
          return {
            name:
              `${file.fileName} ` +
              this.appSettingsService.generate16DigitUUID() +
              `.${fileExtension}`,
            content: blob
          };
        } else {
          console.warn(`Failed to fetch or process file: ${file.file}`);
          return null; // Skip invalid or unprocessed files
        }
      })
    );

    // Filter out any null entries (in case some files failed to process)
    const validFiles = multipleFiles.filter((file) => file !== null);

    if (validFiles.length > 0) {
      const zipFileName = 'TrademarkArtwork';
      // Create and download the zip file
      await this.zipFileService.createAndDownloadZip(validFiles, zipFileName);
    } else {
      console.warn('No valid files to download.');
    }

    this.loaderService.hide();
  }

  onViewMultipleTypeFiles(ev: any) {
    this.dialog.open(ViewTrademarkArtworkComponent, {
      width: '60%',
      data: { images: ev.brandMarksAttachments }
    });
  }

  onViewBrandHistoryListById(ev: any) {
    this.dialog.open(BrandHistoryListComponent, {
      width: '60%',
      data: {
        brandId: ev.brandId,
        companyId: ev.companyId,
        programConfigId: ev.programConfigId
      }
    });
  }

  onBtnActionClick(ev: any): void {
    const actions = ev.key;
    const rowData = ev.data;
    switch (actions) {
      case 'history':
        this.onViewBrandHistoryListById(rowData);
        break;
      case 'ChangeRequest':
        this.onBrandRequestChange(rowData);
        break;
      default:
        break;
    }
  }

  onBrandRequestChange(ev: any) {
    const dialogRef: MatDialogRef<BrandChangeRequestComponent> =
      this.dialog.open(BrandChangeRequestComponent, {
        width: '60%',
        data: {
          brandDetails: ev,
          title: 'Brand change Request'
        }
      });

    dialogRef.afterClosed().subscribe((resp) => {
      if (resp) {
        this.multipleRowCommonTableRef.initLoadItems();
      }
    });
  }
  BrandActionsPayload: any = {};

  onBrandStatusChange(data: any, action: string) {
    Swal.fire({
      title: `Brand ${action == 'terminate' ? 'Terminate' : 'Reactivate'}`,
      text: `Are you sure you want to ${
        action == 'terminate' ? 'terminate' : 'reactivate'
      } the brand?`,
      icon: 'info',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then(async (result) => {
      if (result.isConfirmed) {
        this.loaderService.show();
        this.BrandActionsPayload = {
          BrandApprove:
            action == 'terminate'
              ? 'Terminated'
              : data.brandNameRegistrationId
              ? 'Yes'
              : 'Pending',
          BrandStatus:
            action == 'terminate'
              ? 'Terminated'
              : data.brandNameRegistrationId
              ? 'Active'
              : 'Pending',
          uploadToWebsite: action == 'terminate' ? false : true,
          brandId: +data.brandId
        };

        if (action == 'terminate') {
          let IFC10Payload = {
            companyId: +data?.companyId,
            programConfigId: +data?.programConfigId,
            brandId: +data.brandId,
            userId: +data.userId,
            userEmail: data?.userDetails?.email,
            brandTypeOfTermination: 'BrandUpdate',
            brandDetails: {
              ...data
            }
          };
          this.BrandActionsPayload.action = action;

          this.renewalNoticesService.onBrandProcessIFC10(IFC10Payload);
        } else {
          this.onBrandUpdate(this.BrandActionsPayload);
        }

        try {
        } catch (err) {
          this.appSettingsService.handleError(err);
          this.loaderService.hide();
        }
      }
    });
  }

  onBrandModify(ev: any) {
    const dialogRef: MatDialogRef<BrandEditComponent> = this.dialog.open(
      BrandEditComponent,
      {
        width: '40%',
        data: {
          brandDetails: ev
        }
      }
    );

    dialogRef.afterClosed().subscribe((resp) => {
      if (resp) {
        this.multipleRowCommonTableRef.initLoadItems();
      }
    });
  }

  onRejectBrand(ev: any) {
    // Open the dialog and assign the result to dialogRef
    const dialogRef = this.dialog.open(RejectBrandComponent, {
      width: '60%',
      data: {
        ...ev,
        brandData: [ev],
        title: `Reject Brand - ${ev.CompanyName}`,
        formulationApprovalCode: ev.formulationApprovalCode
      },
      autoFocus: false
    });

    // Subscribe to the dialog close event
    dialogRef.afterClosed().subscribe((resp) => {
      if (resp) {
        setTimeout(() => {
          this.multipleRowCommonTableRef.initLoadItems();
        }, 1000);
      }
    });
  }

  async onBrandUpdate(payload: any) {
    try {
      this.BrandActionsPayload = {
        ...this.BrandActionsPayload
      };

      if (this.BrandActionsPayload.action == 'terminate') {
        this.BrandActionsPayload.expirationTermination = {
          ...payload
        };
      }
      await firstValueFrom(
        this.programBrandingService.updateBrand(
          this.BrandActionsPayload.brandId,
          this.BrandActionsPayload
        )
      );
      this.loaderService.hide();

      await this.swalDialogService.showMessage({
        title: `Brand ${
          this.BrandActionsPayload.action == 'terminate'
            ? 'terminated'
            : 'reactivated'
        } successfully`
      });
      this.multipleRowCommonTableRef.initLoadItems();
    } catch (err) {
      console.error('err :>> ', err);
      this.loaderService.hide();
    }
  }
}
